import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "ngws_admin_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(username, password) {
  const { data } = await axios.post(`${API}/admin/login`, { username, password });
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return data;
}

export const adminApi = {
  quotes: () => axios.get(`${API}/admin/quotes`, { headers: authHeaders() }).then((r) => r.data),
  blockedSlots: () => axios.get(`${API}/admin/blocked-slots`, { headers: authHeaders() }).then((r) => r.data),
  createBlocked: (payload) =>
    axios.post(`${API}/admin/blocked-slots`, payload, { headers: authHeaders() }).then((r) => r.data),
  deleteBlocked: (id) =>
    axios.delete(`${API}/admin/blocked-slots/${id}`, { headers: authHeaders() }).then((r) => r.data),
};

export { API };
